<div class="users-container p-3">
	<mat-card class="p-4 h-100">
		<mat-card-header>
			<mat-card-title class="d-flex justify-content-between align-items-start w-100">
				<app-nav-map></app-nav-map>
				<button mat-flat-button color="primary" class="d-flex justify-content-center align-items-center" (click)="itemAction('NEW')">
					{{ 'BUTTON.CREATE' | translate }} {{ 'USER.TITLE' | translate }}
				</button>
			</mat-card-title>
		</mat-card-header>

		<mat-divider class="w-75 mb-4"></mat-divider>

		<div class="row pb-0 mx-1">
			<div class="mat-elevation-z2 px-0">
				<table mat-table [dataSource]="dataSource">
					@for (column of displayedColumns; track $index) {
					<ng-container [matColumnDef]="column">
						<th mat-header-cell *matHeaderCellDef>
							@switch (column) { @case ('ACTIVE') {
							<mat-select class="table-filter-select" [formControl]="filterUserStatus" (selectionChange)="filterUsers()">
								<mat-option [value]="'ALL'">{{ 'USER.STATUS' | translate }}: {{ 'ASSORTED.ALL' | translate }} </mat-option>
								<mat-option [value]="'ACTIVE'">{{ 'USER.STATUS' | translate }}: {{ 'USER.ACTIVE' | translate }}</mat-option>
								<mat-option [value]="'INACTIVE'">{{ 'USER.STATUS' | translate }}: {{ 'USER.INACTIVE' | translate }}</mat-option>
							</mat-select>
							} @default {
							{{ 'USER.' + column | translate }}
							} }
						</th>
						<td mat-cell *matCellDef="let element" class="cursor-pointer" (click)="itemAction('EDIT', element)">
							@switch (column) { @case ('SCOPES') { @for(scope of element[column.toLowerCase()]; track $index) {
							{{ 'ROLE.' + scope.toUpperCase() | translate }} {{ $last ? '' : '|' }} } } @case ('ROLE') {
							{{ 'ROLE.' + element[column.toLowerCase()]?.toUpperCase() | translate }}
							} @case ('ACTIVE') {
							<div class="d-flex justify-content-end">
								@if(element.active) {
								<button
									mat-icon-button
									color="warn"
									aria-label="Deactivate data item"
									matTooltip="{{ 'BUTTON.DEACTIVATE' | translate }}"
									matTooltipPosition="below"
									(click)="itemAction('DEACTIVATE', element)">
									<mat-icon>person_remove</mat-icon>
								</button>
								} @else {
								<button
									mat-icon-button
									class="activate me-1"
									aria-label="Activate data item"
									matTooltip="{{ 'BUTTON.ACTIVATE' | translate }}"
									matTooltipPosition="below"
									(click)="itemAction('ACTIVATE', element)">
									<mat-icon>person_add</mat-icon>
								</button>
								}

                @if(!element.active) {
                  <button
									mat-icon-button
									color="warn"
									aria-label="Delete data item"
									matTooltip="{{ 'BUTTON.DELETE' | translate }}"
									matTooltipPosition="below"
									(click)="itemAction('DELETE', element)">
									<mat-icon>close</mat-icon>
								</button>
                }
							</div>
							} @default {
							{{ element[column.toLowerCase()] }}
							} }
						</td>
					</ng-container>
					}
					<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
					<tr mat-row *matRowDef="let row; columns: displayedColumns" matTooltip="{{ 'ASSORTED.CLICK_TO_EDIT' | translate }}" matTooltipPosition="below"></tr>
				</table>

				<mat-paginator [pageSizeOptions]="pageOptions" [pageSize]="pageOptions[0]" (page)="getAccounts()" showFirstLastButtons aria-label="Select page of users"> </mat-paginator>
			</div>
		</div>
	</mat-card>
</div>
